const hotelConfig = {
  logo_url: "/assets/Logo_Giga_Hotel.png",
  foto_hero: [
    process.env.PUBLIC_URL + "/assets/Depan.jpeg",
    process.env.PUBLIC_URL + "/assets/Bar.jpeg",
    process.env.PUBLIC_URL + "/assets/Resto.jpeg",
    process.env.PUBLIC_URL + "/assets/Lobi2.jpeg",
    process.env.PUBLIC_URL + "/assets/Lobi1.jpeg",
  ],
  nama: "Giga Owo Ori Hotel - Nias",
  tagline: {
    id: "Dapatkan Pengalaman Terbaik Menginap Anda di Hotel Yang Paling Terbaik, Nyaman, dan Privacy di Pulau Nias.",
    en: "Get Your Best Staying Experience at the Most Comfortable and Private Hotel in Nias Island.",
  },
  kota: "Fodo",
  negara: "Indonesia",
  alamat: {
    id: "Jalan Pelud Binaka Nomor 36, Fodo, Kecamatan Gunungsitoli Selatan, Kota Gunungsitoli, Sumatera Utara 22851",
    en: "Jalan Pelud Binaka No. 36, Fodo, South Gunungsitoli, Gunungsitoli City, North Sumatra 22851, Indonesia",
  },
  telepon: "+62 813 8481 3636",
  whatsapp: "6281384813636",
  email: "gigaowo36@gmail.com",
  warna: {
    primary: "#0D8E8C",
    secondary: "#D4AF00",
    dark: "#1a1a1a",
    surface: "#fffcf7",
  },
  foto_about: [
    process.env.PUBLIC_URL + "/assets/about1.png",
    process.env.PUBLIC_URL + "/assets/about2.png",
    process.env.PUBLIC_URL + "/assets/about3.png",
    process.env.PUBLIC_URL + "/assets/about 4.png",
  ],

  foto_galeri: [
    process.env.PUBLIC_URL + "/assets/01.jpeg",
    process.env.PUBLIC_URL + "/assets/02.jpeg",
    process.env.PUBLIC_URL + "/assets/03.jpeg",
    process.env.PUBLIC_URL + "/assets/04.jpeg",
    process.env.PUBLIC_URL + "/assets/05.jpeg",
    process.env.PUBLIC_URL + "/assets/06.jpeg",
    process.env.PUBLIC_URL + "/assets/07.jpeg",
    process.env.PUBLIC_URL + "/assets/08.jpeg",
    process.env.PUBLIC_URL + "/assets/09.jpeg",
    process.env.PUBLIC_URL + "/assets/010.jpeg",
    process.env.PUBLIC_URL + "/assets/011.jpeg",
    process.env.PUBLIC_URL + "/assets/012.jpeg",
    process.env.PUBLIC_URL + "/assets/013.jpeg",
    process.env.PUBLIC_URL + "/assets/014.jpeg",
    process.env.PUBLIC_URL + "/assets/015.jpeg",
    process.env.PUBLIC_URL + "/assets/016.jpeg",
    process.env.PUBLIC_URL + "/assets/017.jpeg",
    process.env.PUBLIC_URL + "/assets/019.jpeg",
    process.env.PUBLIC_URL + "/assets/020.jpeg",
    process.env.PUBLIC_URL + "/assets/021.jpeg",
    process.env.PUBLIC_URL + "/assets/022.jpeg",
    process.env.PUBLIC_URL + "/assets/023.jpg.jpeg",
    process.env.PUBLIC_URL + "/assets/24jpg.jpg.jpeg",
    process.env.PUBLIC_URL + "/assets/25.jpg.jpeg",
    process.env.PUBLIC_URL + "/assets/26.jpg.jpeg",
  ],

  stats: {
    kamar: "21+",
    layanan: "24/7",
    kepuasan: "100%",
  },

  highlights: [
    {
      icon: "car",
      title: { id: "Jemput & Antar", en: "Pick-up & Drop" },
      desc: {
        id: "Tersedia jasa Jemput & Antar dari Bandara Binaka ke Hotel dan sebaliknya.",
        en: "Airport transfer service available from Binaka Airport to Hotel and vice versa.",
      },
    },
    {
      icon: "parking",
      title: { id: "Parkir Gratis", en: "Free Parking" },
      desc: {
        id: "Tersedia area parkir yang aman",
        en: "Secure parking area available",
      },
    },
    {
      icon: "wifi",
      title: { id: "WiFi Gratis", en: "Free WiFi" },
      desc: {
        id: "Tersedia koneksi WiFi berkecepatan tinggi",
        en: "High-speed WiFi connection available",
      },
    },
    {
      icon: "clock",
      title: { id: "Layanan 24 Jam", en: "24-Hour Service" },
      desc: {
        id: "Kami melayani selama 24 jam untuk Anda",
        en: "We serve you 24 hours a day",
      },
    },
    {
      icon: "restaurant",
      title: { id: "Restoran", en: "Restaurant" },
      desc: {
        id: "Tersedia makanan Nasional dan Internasional",
        en: "National and International cuisine available",
      },
    },
    {
      icon: "billiard",
      title: { id: "Billiards", en: "Billiards" },
      desc: {
        id: "Tersedia meja billiard untuk hiburan",
        en: "Billiard table available for entertainment",
      },
    },
  ],

  tipe_kamar: [
    {
      nama: { id: "Kamar Standar", en: "Standard Room" },
      deskripsi: {
        id: "Kamar nyaman dengan pemandangan taman, cocok untuk perjalanan bisnis maupun liburan.",
        en: "Comfortable room with garden view, ideal for business or leisure travel.",
      },
      harga: 350000,
      ukuran: "24 m²",
      kapasitas: 2,
      lantai: "2-3",
      smoking: false,
      rating: 4.5,
      ulasan: 28,
      tags: {
        id: [
          "Kasur Queen",
          "AC",
          "WiFi",
          "TV Kabel",
          "Kamar Mandi Dalam",
          "Non-Smoking",
        ],
        en: [
          "Queen Bed",
          "AC",
          "WiFi",
          "Cable TV",
          "Private Bathroom",
          "Non-Smoking",
        ],
      },
      foto: "https://images.pexels.com/photos/2506990/pexels-photo-2506990.jpeg?auto=compress&cs=tinysrgb&w=1500",
      tersedia: true,
    },
    {
      nama: { id: "Kamar Deluxe", en: "Deluxe Room" },
      deskripsi: {
        id: "Kamar luas dengan dekorasi premium dan pemandangan kota yang indah dari lantai atas.",
        en: "Spacious room with premium decor and beautiful city view from upper floors.",
      },
      harga: 500000,
      ukuran: "32 m²",
      kapasitas: 2,
      lantai: "4-5",
      smoking: false,
      rating: 4.7,
      ulasan: 45,
      tags: {
        id: [
          "Kasur King",
          "AC",
          "WiFi",
          "TV Kabel",
          "Bathtub",
          "Minibar",
          "Non-Smoking",
        ],
        en: [
          "King Bed",
          "AC",
          "WiFi",
          "Cable TV",
          "Bathtub",
          "Minibar",
          "Non-Smoking",
        ],
      },
      foto: "https://images.pexels.com/photos/1001965/pexels-photo-1001965.jpeg?auto=compress&cs=tinysrgb&w=1500",
      tersedia: true,
    },
    {
      nama: { id: "Kamar Suite", en: "Suite Room" },
      deskripsi: {
        id: "Pengalaman menginap mewah dengan ruang tamu terpisah, jacuzzi, dan pemandangan panoramik.",
        en: "Luxurious stay with separate living room, jacuzzi, and panoramic views.",
      },
      harga: 750000,
      ukuran: "56 m²",
      kapasitas: 3,
      lantai: "6",
      smoking: false,
      rating: 4.9,
      ulasan: 19,
      tags: {
        id: [
          "Kasur King",
          "AC",
          "WiFi",
          "TV Kabel",
          "Jacuzzi",
          "Minibar",
          "Ruang Tamu",
          "Non-Smoking",
        ],
        en: [
          "King Bed",
          "AC",
          "WiFi",
          "Cable TV",
          "Jacuzzi",
          "Minibar",
          "Living Room",
          "Non-Smoking",
        ],
      },
      foto: "https://images.pexels.com/photos/6626144/pexels-photo-6626144.jpeg?auto=compress&cs=tinysrgb&w=1500",
      tersedia: true,
    },
    {
      nama: { id: "Kamar Smoking", en: "Smoking Room" },
      deskripsi: {
        id: "Kamar nyaman yang diperuntukkan bagi tamu perokok dengan ventilasi udara khusus.",
        en: "Comfortable room for smoking guests with special air ventilation system.",
      },
      harga: 350000,
      ukuran: "24 m²",
      kapasitas: 2,
      lantai: "2-3",
      smoking: true,
      rating: 4.3,
      ulasan: 12,
      tags: {
        id: [
          "Kasur Queen",
          "AC",
          "WiFi",
          "TV Kabel",
          "Kamar Mandi Dalam",
          "Smoking",
        ],
        en: [
          "Queen Bed",
          "AC",
          "WiFi",
          "Cable TV",
          "Private Bathroom",
          "Smoking",
        ],
      },
      foto: "https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg?auto=compress&cs=tinysrgb&w=1500",
      tersedia: true,
    },
  ],
  testimoni: [
    {
      nama: "Ahmad S.",
      rating: 5,
      komentar: {
        id: "Hotel yang sangat nyaman dengan pelayanan yang ramah. Sangat direkomendasikan!",
        en: "A very comfortable hotel with friendly service. Highly recommended!",
      },
    },
    {
      nama: "Maria L.",
      rating: 5,
      komentar: {
        id: "Pengalaman hotel terbaik yang pernah saya rasakan. Kolam renang saat matahari terbenam sangat indah.",
        en: "The best hotel experience I've had. The pool at sunset is breathtaking.",
      },
    },
    {
      nama: "Budi P.",
      rating: 5,
      komentar: {
        id: "Kemewahan yang sesungguhnya. Dari penjemputan hingga check-out, semuanya sempurna.",
        en: "Luxury redefined. From pick-up to check-out, everything was seamless.",
      },
    },
  ],
};

export default hotelConfig;
